import React, { useCallback, useEffect, useState } from "react";
import historyUtils from "../../../libs/history.utils";
import { useParams } from "react-router-dom";
import RouteName from "../../../routes/Route.name";
import { useDispatch } from "react-redux";
import { serviceDownloadMyDocSampleCSv, serviceDownloadSampleCSv, serviceGetProgramDetails } from "../../../services/Program.service";
import history from "../../../libs/history.utils";
import SnackbarUtils from "../../../libs/SnackbarUtils";
 


const useProgramDetailHook = () => {
  const [programDetails, setProgramDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isCsvDialog, setIsCsvDialog] = useState(false);
  const [isMyDocDialog, setMyDocDialog] = useState(false);
  const [isPetDialog, setIsPetDialog] = useState(false);
  const [isSidePanel, setSidePanel] = useState(false);
  const [renderList ,setRenderList] = useState(false);
  const [renderRewardList ,setRenderRewardList] = useState(false);
  const [renderMyDocList ,setMyDocRenderList] = useState(false);
  const [renderPetList ,setRenderPetList] = useState(false);
  const [renderGiftList, setRenderGiftList] = useState(false);
  const [editData, setEditData] = useState(null);
  const [editId, setEditId] = useState("");
  const { id } = useParams();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const openDialog = () => {
    setIsDialogOpen(true);
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
  };

  useEffect(() => {
    serviceGetProgramDetails({ id: id ? id : "" }).then((res) => {
      if (!res?.error) {
        setProgramDetails(res?.data?.details);
      }
    });
  }, [id]);

  const toggleCsvDialog = useCallback(() => {
    setIsCsvDialog((e) => !e);
  }, [setIsCsvDialog]);

  const toggleMyDocDialog = useCallback(() => {
    setMyDocDialog((e) => !e);
  }, [setMyDocDialog]);

  const togglePetDialog = useCallback(() => {
    setIsPetDialog((e) => !e);
  }, [setIsPetDialog]);

  const handleSampleDownload = useCallback(() => {
    serviceDownloadSampleCSv().then((res) => {
      if (!res.error) {
        const data = res.data?.file;
        window.open(data, "_blank");
      }
    });
  }, []);

  const handleSampleMyDocDownload = useCallback(() => {
    serviceDownloadMyDocSampleCSv().then((res) => {
      if (!res.error) {
        const data = res.data?.file;
        window.open(data, "_blank");
      }
    });
  }, []);

  // const handleEdit = useCallback(
  //   (data) => {
      
  //     history.push(`${RouteName.PRODUCT_UPDATE}${data?.id}`)
  //   },
  //   [setEditData, setEditId]
  // );
 
  const handleEdit = useCallback(() => {
    if (id) {
      history.push(`${RouteName.PROGRAM_UPDATE}${id}`);
    } else {
      console.error('ID is undefined');
    }
  }, [id, history]);


const updateCsVList = useCallback(()=>{
  setRenderList((s)=>!s)
},[renderList])

const updateRewardList = useCallback(()=>{
  setRenderRewardList((s)=>!s)
},[renderRewardList])

const updateMyDocList = useCallback(()=>{
  setMyDocRenderList((s)=>!s)
},[renderMyDocList])

const updatePetList = useCallback(()=>{
  setRenderPetList((s)=>!s)
},[renderPetList])

const updateGiftList = useCallback(()=>{
  setRenderGiftList((s)=>!s)
},[renderGiftList])
 
// const handleCreate = useCallback(() => {
//   history.push(`${RouteName.QUIZ_CREATE}`),{
//     Client: programDetails?.client?.name
//   }
// }, []);
const handleCreate = useCallback(() => {
  if (id) {
   
    history.push(`${RouteName.QUIZ_CREATE}`,{
      Client: {
        name: programDetails?.client?.name.charAt(0).toUpperCase() + programDetails?.client?.name.slice(1),
        label: programDetails?.client?.name.charAt(0).toUpperCase() + programDetails?.client?.name.slice(1),
        id: programDetails?.client?.id
      },
      Name: [{id: programDetails?.id, 
        label: programDetails?.name,
        name: programDetails?.name}],
      customerID:programDetails?.id
    });

  }
}, [id, programDetails]);

const handleHealthCreate = useCallback(() => {
  if (id) {
   
    history.push(`${RouteName.HEALTH_CREATE}`,{
      Client: {
        name: programDetails?.client?.name.charAt(0).toUpperCase() + programDetails?.client?.name.slice(1),
        label: programDetails?.client?.name.charAt(0).toUpperCase() + programDetails?.client?.name.slice(1),
        id: programDetails?.client?.id
      },
      Name: [{id: programDetails?.id, 
        label: programDetails?.name,
        name: programDetails?.name}],
      customerID:programDetails?.id
    });

  }
}, [id, programDetails]);

  return {
    programDetails,
    isLoading,
    isSidePanel,
    id,
    openDialog,
    closeDialog,
    isDialogOpen,
    handleEdit,
    handleSampleDownload,
    toggleCsvDialog,
    isCsvDialog,
    updateCsVList,
    renderList,
    renderRewardList,
    updateRewardList,
    togglePetDialog,
    isPetDialog,
    updatePetList,
    renderPetList,
    isMyDocDialog,
    updateMyDocList,
    renderMyDocList,
    updateMyDocList,
    toggleMyDocDialog,
    handleSampleMyDocDownload,
    handleCreate,
    handleHealthCreate,
    renderGiftList, 
    updateGiftList
  };
};

export default useProgramDetailHook;
